import type * as ecModels from '../../../models'

import type { Plugin } from './plugin'

// TODO: nothing needed right now, but leaving so that we don't have to do a
// big refactor if/when we need something here
export class Selectors<TTypeParams extends ecModels.TypeParams.Constraint> {
  constructor(plugin: Plugin<TTypeParams>) {}
}
